(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('NewFeatureDeleteController', NewFeatureDeleteController);

    NewFeatureDeleteController.$inject = ['$uibModalInstance', 'entity', 'NewFeature'];

    function NewFeatureDeleteController($uibModalInstance, entity, NewFeature) {
        var vm = this;

        vm.feature = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            NewFeature.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
